import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useI18n } from 'vue-i18n'
import { useTimesheets } from '../store/timesheets'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerDeniedTimecard',
  setup(__props) {

const { hasDenied } = storeToRefs(useTimesheets())

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`timecard.${key}`)

return (_ctx: any,_cache: any) => {
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_unref(hasDenied))
    ? (_openBlock(), _createBlock(_component_q_banner, {
        key: 0,
        class: "text-white bg-negative q-mb-md"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(label('denied')), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})